import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *我的团队文案列表
 * @param params
 * 
*/

export const myCopywriting = params => Http.get(`${baseUrl}/sz/team/wa/my`, { params })

/**
 *文案详情
 * @param waId
 * 
*/

export const info = waId => Http.get(`${baseUrl}/sz/team/wa/${waId}`)

/**
 *新增文案
 * @param params
 * 
*/

export const save = params => Http.post(`${baseUrl}/sz/team/wa/my`,  params )

/**
 *修改文案
 * @param params
 * 
*/

export const edit = params => Http.put(`${baseUrl}/sz/team/wa/my`,  params )

/**
 *删除文案
 * @param ids
 * 
*/

export const del = ids => Http.delete(`${baseUrl}/sz/team/wa/my/${ids}` )

/**
 *团队成果
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/wa`, { params })